import { useQuery } from '@tanstack/react-query';
import { getSurveyLink } from '~/api';
import dartKey from './dartKey';

const useSurveyLinkQuery = () => {
  return useQuery({
    queryKey: dartKey.getSurveyLink(),
    queryFn: async () => {
      const { data, status } = await getSurveyLink();
      if (status === 200) {
        return data.links[0];
      }
      throw new Error('Failed to get survey link');
    },
  });
};

export default useSurveyLinkQuery;
